const data = [
    {title: 'Book Saver', 
    type: 'Collaboration', 
    time: '20 hours', 
    stack: 'React, HTML, CSS, Javascript, Cypress, Router', 
    info: 'Developed a web application that uses the NY Times Bestsellers API to help you navigate the different lists effectively.', 
    github: 'https://github.com/LordSchwifty/Book-Saver', deployed: 'https://trevorfitz0.github.io/Book-Saver/#/',
    image: '../Images/bg2.png'},
    {title: 'Rancid Tomatillos', 
    type: 'Collaboration', 
    time: '25 hours', 
    stack: 'React, HTML, CSS, Javascript, Cypress, Router', 
    info: 'Created a movie ratings web app that allows the user to read and view ratings of recently released flicks.', 
    github: 'https://github.com/LordSchwifty/rancid-tomatillos', 
    deployed: 'https://lordschwifty.github.io/rancid-tomatillos/', 
    image: '../Images/bg2.png'}
  ]

  export { data };